import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import TextButton from 'components/Luxkit/Button/TextButton'
import LineMapIcon from 'components/Luxkit/Icons/line/LineMapIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import {
  googleMapsQueryUrl,
  convertBedbankPropertyAddressToString,
} from 'tripPlanner/utils'

interface Prop {
  address: string | App.BedbankPropertyAddress
  placeName?: string
  addressLabel?: string
  placeId?: string
}

const Address = styled.div`
  display: flex;
  flex-direction: column;
`

const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  gap: ${rem(8)};
  border-bottom: 1px solid ${props => props.theme.palette.neutral.default.six};

  & > button,
  a {
    flex: 1;
  }
`

function AddressWithViewMapButton({
  placeId,
  placeName,
  address,
  addressLabel = 'Address',
}: Prop) {
  const getAddress = () => {
    if (typeof address === 'string') {
      return address
    }

    return convertBedbankPropertyAddressToString(address)
  }

  const mapsUrl = googleMapsQueryUrl(getAddress(), placeId)

  return (
    <>
      <Address>
        <BodyText variant="medium" weight="semi-bold">
          {addressLabel}
        </BodyText>
        {placeName && <BodyText variant="large">{placeName}</BodyText>}
        <BodyText variant="large">{getAddress()}</BodyText>
      </Address>
      <Actions>
        <TextButton
          kind="secondary"
          startIcon={<LineMapIcon />}
          target="_blank"
          href={mapsUrl}
        >
          View on Google Maps
        </TextButton>
      </Actions>
    </>
  )
}

export default AddressWithViewMapButton
